function renderNav() {
	let data = {
		opener: $('[data-nav="opener"]'),
		icon: $('[data-nav="icon"]'),
		box: $('[data-nav="box"]')
	};

	data.opener.on('click', function () {
		data.icon.toggleClass('is--open');
		data.box.toggleClass('is--open');
	});
}